/* tslint:disable */

declare var Object: any;
export interface PuestoInterface {
  "idPuesto"?: number;
  "nombre": string;
  "descripcion"?: string;
  "pathLogo"?: string;
}

export class Puesto implements PuestoInterface {
  "idPuesto": number;
  "nombre": string;
  "descripcion": string;
  "pathLogo": string;
  constructor(data?: PuestoInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Puesto`.
   */
  public static getModelName() {
    return "Puesto";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Puesto for dynamic purposes.
  **/
  public static factory(data: PuestoInterface): Puesto{
    return new Puesto(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Puesto',
      plural: 'Puestos',
      path: 'Puestos',
      idName: 'idPuesto',
      properties: {
        "idPuesto": {
          name: 'idPuesto',
          type: 'number'
        },
        "nombre": {
          name: 'nombre',
          type: 'string'
        },
        "descripcion": {
          name: 'descripcion',
          type: 'string'
        },
        "pathLogo": {
          name: 'pathLogo',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/Puesto.ts